// extracted by mini-css-extract-plugin
export default {"taskEvaluationSort":"TaskEvaluationSort_taskEvaluationSort__L9FgN","taskEvaluationSortInput":"TaskEvaluationSort_taskEvaluationSortInput__Ay2jJ"};